import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/zipCode/check';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/2c8ab43b-90ff-4eb7-b0f6-5ef8c2d7daa0?version=e108b88d-e44f-49ee-8b46-4c64ad6068fe&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '01',
    bussinessErrorVariant: 'zipCodeNotFilled',
    message: 'ZipCode not filled',
  },
  {
    code: '02',
    bussinessErrorVariant: 'zipCodeNotExists',
    message: 'ZipCode does not exists',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
